import React, { useContext, useState, useRef, useEffect } from 'react';
import { MediaOverlayContext } from '../../context/MediaOverlayContext';
import './DogPreTaggerOverlay.css';

const DogPreTaggerOverlay = () => {
  const { availableDogs, preTaggedDogIds, setPreTaggedDogIds } = useContext(MediaOverlayContext);
  const [expanded, setExpanded] = useState(false);
  const wrapperRef = useRef(null);

  const toggleDog = (id) => {

    console.log('id',id);

    setPreTaggedDogIds(prev =>
      prev.includes(id) ? prev.filter(dogId => dogId !== id) : [...prev, id]
    );
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setExpanded(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);


  console.log('availableDogs===>', availableDogs);

  return (
    <div ref={wrapperRef} className={`dog-pretagger ${expanded ? 'expanded' : ''}`}>
      <button onClick={() => setExpanded(prev => !prev)} className="dog-pretagger__toggle">
        🐾 Tag
      </button>

      {expanded ? (
        <div className="dog-pretagger__list">
          {availableDogs.map(dog => (
            <label key={dog.id} className="dog-pretagger__item">
              <input
                type="checkbox"
                checked={preTaggedDogIds.includes(dog.id)}
                onChange={() => toggleDog(dog.id)}
              />
              {dog.name}
            </label>
          ))}
        </div>
      ) : (
        <div className="dog-pretagger__tags">
          {preTaggedDogIds.map(id => {
            const dog = availableDogs.find(d => d.id === id);
            return dog ? <div key={id} className="dog-pretagger__tag">{dog.name}</div> : null;
          })}
        </div>
      )}
    </div>
  );
};

export default DogPreTaggerOverlay;
